import React, { useState, useRef, useEffect, useLayoutEffect } from 'react';
import { Grid, Avatar, Box, Container, Typography, Paper, styled, Tabs, Tab } from '@mui/material';
import AddCommentIcon from '@mui/icons-material/AddComment';
import { useTheme } from '@emotion/react';
import YetaiPiece from "../../components/yetaipiece";
import headerbg from "../../assets/mybg.jpg";
import img_test from "../../assets/test.png";
import img_test1 from "../../assets/swiper0.png";
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import { Link } from 'react-router-dom';
import EventNoteOutlinedIcon from '@mui/icons-material/EventNoteOutlined';
import { useDispatch, useSelector } from 'react-redux';
import { fetchYetaiSearchMy,ClearData } from '../../store/features/my';
import { Fade } from '@mui/material';
const getParameterByName = (name, url) => {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
  const results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export default function Example() {
  // 声明一个新的叫做 “count” 的 state 变量
  const a = Math.random();
  const theme = useTheme();
  const [show, setShow] = useState(false);
  const { yetaiViewed, yetaiLiked } = useSelector(store => (store.my));
  const dispatch = useDispatch();


  //默认进入就是介绍
  const [tabIdx, setTabIdx] = useState("1");
  const [nick, setNick] = useState("");
  const [head, setHead] = useState("");

  const updateJieShao = (data, newValue) => {
    console.log("dataP::::", newValue);
    setTabIdx(newValue);

  }
  // const [nick, setNick] = useState(localStorage.getItem('openid'));
  // const [openId, setOpenId] = useState(localStorage.getItem('nickname'));
  // const [avatar, setAvatar] = useState(localStorage.getItem('avatar'));
  // let nickname = localStorage.getItem('openid');

  let openid = getParameterByName('openid');
  let nickname = getParameterByName('nickname');
  let avatar = getParameterByName('avatar');

  const AntTab = styled((props) => <Tab {...props} />)(
    ({ theme }) => ({
      textTransform: "none",
      minWidth: 0,
      [theme.breakpoints.up("sm")]: {
        minWidth: 0,
      },
      fontSize: '1.05rem',
      fontWeight: theme.typography.fontWeightRegular,
      marginRight: theme.spacing(1),
      color: "rgba(0, 0, 0, 0.85)",
      fontFamily: [
        "-apple-system",
        "BlinkMacSystemFont",
        '"Segoe UI"',
        "Roboto",
        '"Helvetica Neue"',
        "Arial",
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(","),
      "&:hover": {
        color: theme.palette.primary.mainsat,
        opacity: 1,
      },
      "&.Mui-selected": {
        color: theme.palette.mgreen.main,
        fontWeight: theme.typography.fontWeightMedium,
      },
      "&.Mui-focusVisible": {
        backgroundColor: "#d1eaff",
      },
    })
  );

  const WaterFall = () => {

    const { data } = useSelector(store => store.my)
    // const { yetaiViewed, yetaiLiked } = useSelector(store => (store.my));
    // const dispatch = useDispatch();
    // useEffect(() => {
    //   console.log(yetaiViewed, yetaiLiked, tabIdx)
    //   let _b
    //   if (tabIdx == "1") {
    //     _b = yetaiViewed ? yetaiViewed.join(',') : null;
    //   }
    //   else {
    //     _b = yetaiLiked ? yetaiLiked.join(',') : null;
    //   }
    //   console.log("yetaiLiked:",yetaiLiked);

    //   console.log('3333333333333333')
    //   dispatch(fetchYetaiSearchMy(
    //     {
    //       bid: _b
    //     }
    //   ))
    // }, [])

    return (
      <ImageList variant="masonry" cols={2} gap={8} sx={{ padding: "16px" }}>
        {data && data.map((item, index) => (
          <ImageListItem key={index}>
            <YetaiPiece data={item}></YetaiPiece>
          </ImageListItem>
        ))}
      </ImageList>
    )
  }

  useEffect(() => {
    setShow(true);


    console.log(yetaiViewed, yetaiLiked, tabIdx)
    let _b
    if (tabIdx == "1") {
      _b = yetaiViewed ? yetaiViewed.join(',') : null;
    }
    else {
      _b = yetaiLiked ? yetaiLiked.join(',') : null;
    }

    dispatch(ClearData());

    if (_b && _b != '') {
      dispatch(fetchYetaiSearchMy(
        {
          page: 1,
          size: 99,
          bid: _b
        }
      ))
    }
   

    let callbackurl = (window.location.href).replace('#/my','');

    if (!openid) {
      if (localStorage.getItem('openid', openid)) {
        openid = localStorage.getItem('openid');
        nickname = localStorage.getItem('nickname');
        avatar = localStorage.getItem('avatar');
      }
      else {
        // console.log(`https://jxadmin.hyr123.top/wechat/mp/oauth?callback=${callbackurl}`)
        window.location.replace(`https://jxadmin.hyr123.top/wechat/mp/oauth?callback=${callbackurl}
        `);
      }
    }
    else {
      let openid = getParameterByName('openid');
      let nickname = getParameterByName('nickname');
      let avatar = getParameterByName('avatar');

      localStorage.setItem('openid', openid);
      localStorage.setItem('nickname', nickname);
      localStorage.setItem('avatar', avatar);
    }
    setHead(avatar);
    setNick(nickname);
    console.log(openid,nickname,avatar);

  }, [tabIdx]);

  return (
    <Fade in={show}>
      <Container sx={{ padding: 0 }}>
        <Container sx={{ backgroundImage: `url(${headerbg})`, backgroundSize: 'cover', padding: '20px 20px 10px 20px', borderRadius: '0px', width: '100vw', height: '100vw', 'max-height': "200px" }}>
          <Grid container spacing={1} marginTop={2} alignItems="center">
            <Grid xs={8} item alignContent={"center"} alignItems={'center'} container spacing={1} >
              <Grid item xs={"auto"}>
                <Avatar sx={{ width: 70, height: 70 }} alt="Remy Sharp" src={head} />
              </Grid>
              <Grid item>
                <Box sx={{ fontWeight: "bold", color: "#333333", fontSize: '1.2rem', letterSpacing: '4px' }}>{nick}</Box>
              </Grid>
            </Grid>
            <Grid xs={4} item justifyContent="flex-end"
              alignItems="flex-start" container>
              <Link to="/advice">
                <Container sx={{ display: 'flex', justifyContent: 'center', alignContent: 'center', flexWrap: 'wrap' }}>
                  <EventNoteOutlinedIcon sx={{ color: "#555555" }} />
                  <Box sx={{ fontWeight: "normal", color: '#333333', fontSize: '0.8rem', letterSpacing: '1px', marginTop: '0rem' }}>意见建议</Box>
                </Container>
              </Link>
            </Grid>
          </Grid>
        </Container>

        <Container sx={{ padding: '0px', borderTopLeftRadius: '10px', borderTopRightRadius: '10px', marginTop: '-1.5rem', backgroundColor: theme.palette.primary.darkwhite }}>
          <Container sx={{ padding: '16px' }}>
            {/* <Grid container spacing={1} alignItems={'center'}>
              <Grid item>
                <Box sx={{ width: 4, height: 20, backgroundColor: theme.palette.primary.main }}></Box>
              </Grid>
              <Grid item>
                <Box sx={{ fontWeight: "normal", color: '#000', fontSize: '1rem', letterSpacing: '1px' }}>浏览记录
                </Box>
              </Grid>
            </Grid> */}
          </Container>

          {/* <MyTab tabIdx={tabIdx} change={updateJieShao}></MyTab> */}
          <Grid container justifyContent={'center'}>
            <Grid>
              <Tabs
                value={tabIdx}
                onChange={updateJieShao}
                textColor="secondary"
                indicatorColor="secondary"
                aria-label="secondary tabs example"
                sx={{
                  '& .MuiTabs-indicator': {
                    backgroundColor: theme.palette.mgreen.main,
                    top: 'calc(100% - 9px)', // 调整指示器与文字的高度
                  },
                }}
              >
                <AntTab value="1" label="浏览记录" />
                {/* <AntTab value="2" label="喜欢" /> */}
              </Tabs>
            </Grid>
          </Grid>

          <WaterFall></WaterFall>
        </Container>
      </Container>
    </Fade>
  );
}